import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import "../home.css";

export default function EndlessLearning() {
  return (
    <motion.div
      className="infinite-container"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1.2 }}
    >
      <div className="bg-3d-text1">ACADME</div>
      <div className="infinite-content">
        <motion.div
          className="infinite-left"
          initial={{ opacity: 0, y: 50, scale: 0.9 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          transition={{ duration: 1.4, ease: "easeOut" }}
        >
          <motion.h1
            className="hero-3d-text"
            initial={{ rotateX: -90, opacity: 0 }}
            animate={{ rotateX: 0, opacity: 1 }}
            transition={{ duration: 1.5, ease: "easeOut" }}
          >
            One Click. <br />
            <span>Endless Learning.</span>
          </motion.h1>

          {/* <motion.p 
            className="hero-sub"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 1.3 }}
          >
            Empower your future with industry-ready skills, real internships,
            and expert mentorship — all in one platform.
          </motion.p> */}

          <motion.p
            className="hero-small"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 1.6 }}
          >
            Transform Your Future with just One Click. Explore, Upgrade, and Excel.
          </motion.p>

          <motion.div
            className="btn-group"
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 2 }}
          >
            <Link to="/form">
            <button className="btn-primary">Request Demo Session</button>
            </Link>
            {/* <button className="btn-outline">Explore Programs</button> */}
            <Link to="/programs">
          <button className="btn-outline">Explore Programs</button>
           </Link>
          </motion.div>
        </motion.div>
      </div>
    </motion.div>
  );
}
